<template>
  <b-modal id="profile-menu-modal" hide-footer>
    <template #modal-header>
      <CloseButton modal-name="profile-menu-modal" />
    </template>
    <UserSection />
    <div class="divider"></div>
    <LogoutSection />
  </b-modal>
</template>

<script>
import CloseButton from 'UI/CloseButton';
import UserSection from '@/components/Header/ProfileMenu/UserSection';
import LogoutSection from '@/components/Header/ProfileMenu/LogoutSection';
export default {
  name: 'MenuProfile',
  components: {
    UserSection,
    LogoutSection,
    CloseButton
  }
};
</script>

<style lang="scss">
#profile-menu-modal {
  .modal-header {
    border: none;
    padding: 0;
  }
  .modal-dialog {
    width: 300px;
    margin-left: calc(100% - 315px);
    margin-right: 15px;
    margin-top: 80px;
    border-radius: 10px;
    .modal-body {
      padding: 0px;
      .divider {
        width: 80%;
        height: 1px;
        background-color: $gray;
        margin: 0 auto;
      }
      .close-icon {
        position: absolute;
      }
    }
    @include sm {
      width: 85%;
      margin: auto;
      margin-top: 45px;
    }
    @include xs {
      width: 95%;
    }
  }
  .close {
    outline: none;
    position: absolute;
    right: 20px;
    top: -20px;
    width: 30px;
    border-radius: 50%;
    justify-content: center;
    height: 30px;
    display: flex;
    text-align: center;
    align-items: center;
    color: white;
    opacity: 1;
    font-weight: 400;
    z-index: 100;
    @include md {
      right: 20px;
      top: 20px;
      background-color: #505050;
    }
  }
}
</style>
